import { Link, useLocation } from 'react-router-dom';

import { Avatar } from '../../../common/Avatar';
import { useAuth } from '../../../contexts/AuthContext';

// import { useAuth } from '../../../../utils/AuthContext';

export function SidebarProfile(): JSX.Element {
  const { userData } = useAuth();
  const location = useLocation();
  const isActive = location.pathname === '/profile';

  const getAvatarUrl = (): string => {
    const avatarUrl = userData?.avatarUrl;
    if (!avatarUrl) return '/profile.jpeg'; // Fallback to local image

    // If it's a Google profile image, ensure it has the correct parameters
    if (avatarUrl.includes('googleusercontent.com')) {
      // Remove any size parameters and add a new one
      const baseUrl = avatarUrl.split('=')[0];
      return `${baseUrl}=s96-c`;
    }

    return avatarUrl;
  };
  return (
    <Link
      to="/profile"
      className={`flex items-center py-3 justify-center gap-3  self-stretch ${
        isActive ? 'text-md border-r-[3px] border-r-[#CE3F4F]' : ''
      } `}
    >
      <Avatar src={getAvatarUrl()} size="sm" name={userData?.fullName || ''} />
      <span className="text-md text-gray-700 truncate text-ellipsis">
        {userData?.fullName || userData?.email}
      </span>
    </Link>
  );
}
